<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header :title="$t('Points Logs')" class="common-header">
        <mt-button slot="left" icon="back" @click="one ? onPage('index') : $router.go(-1)"></mt-button>
      </mt-header>
    </div>
      <div class="list-wrapper" ref="listWrapper" @scroll="handleScroll" v-if="point_list && point_list.length">
        <div class="point-list" v-for="(item, index) in point_list" :key="item.pl_id">
          <div class="info">
            <div class="title">{{ item.desc }}</div>
            <div class="time">{{ item.create_time }}</div>
          </div>
          <div :class="item.type == 1 ? 'number' : 'diture'">{{ item.type == 1 ? '+' : '-' }}{{ item.points }}</div>
        </div>
        <!-- <div class="more" v-if="isMore" @click="loadMore">{{ $t('yi21') }}</div> -->
      </div>
      <empty-record v-else-if="point_list && !point_list.length"></empty-record>
      <div class="exchange" @click="goExchange">{{ $t('My Points') }}：{{ myPoints }}，{{ $t('Go Excharge') }}>></div>
  </div>
</template>

<script>
import { getPointList, pointsExchange } from '../../../api/memberPoint';
import { Toast, MessageBox, Indicator } from "mint-ui";
import EmptyRecord from '../../../components/EmptyRecord';
import { getMemberIndex } from "../../../api/member";

export default {
  name: 'BalanceHistory',
  components: {
    EmptyRecord
  },
  props: {
      one: {
          default: false,
          type: Boolean
      },
  },
  data() {
    return {
      myPoints: 0,
      params: { page: 1, per_page: 10 },
      loading: false,
      isMore: true,
      point_list: []
    };
  },
  created() {
    this.getMemberInfo();
    this.refreshPointList();
  },
  mounted() {},
  methods: {
    onPage(v, val) {
        this.$emit('onPage', v, val)
    },
    handleScroll() {
      const container = this.$refs.listWrapper;
      const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
      if (scrollBottom < 10) {
        this.loadMore();
      }
    },
    getMemberInfo() {
      getMemberIndex().then(response => {
        if (response && response.result.member_info) {
          this.myPoints = response.result.member_info.member_points;
        }
      }).catch(error => {
        Toast(error.message || 'Error occurred');
      });
    },
    goExchange() {
      if(this.myPoints <= 0) return Toast(this.$t('yi11'))
      //确定将积分全部兑换成余额吗？
      MessageBox({
        title: this.$t('MessageBox.Tips'),
        message: this.$t('Confirm points excharge'),
        confirmButtonText: this.$t('MessageBox.Confirm'),
        cancelButtonText: this.$t('MessageBox.Cancel'),
        showCancelButton: true
      }).then(() => {
        Indicator.open();
        return pointsExchange();
      }).then(res => {
        Indicator.close();
        if (res.code == 10000) {
          this.refreshPointList();
        }
        Toast(res.message);
      }).catch(error => {
        Indicator.close();
        if (error !== 'cancel') {
          Toast(error.message || 'Error occurred');
        }
      });
    },
    loadMore() {
      if (!this.isMore || this.loading) return;
      this.loading = true;
      this.params.page += 1;
      this.getPointList();
    },
    refreshPointList() {
      this.params.page = 1;
      this.point_list = [];
      this.isMore = true;
      this.getPointList();
      this.getMemberInfo();
    },
    getPointList() {
      Indicator.open();
      getPointList(this.params).then(res => {
        Indicator.close();
        this.loading = false;
        if (res.result.hasmore) {
          this.isMore = true;
        } else {
          this.isMore = false;
        }
        const temp = res.result.log_list;
        if (temp) {
          this.point_list = this.point_list.concat(temp);
        }
      }).catch(error => {
        Indicator.close();
        this.loading = false;
        Toast(error.message || 'Error occurred');
      });
    }
  }
}
</script>

<style scoped lang="scss">
.exchange {
  position: fixed;
  bottom: 10%;
  width: 90%;
  background-color: #FB2630;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  padding: 10px 0;
  border-radius: 30px;
  left: 5%;
}

.container {
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.header {
  border-bottom: 1px solid #e8eaed;
}

.list-wrapper {
  height: 94vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

  .point-list {
    background-color: #fff;
    border-bottom: 1px solid #e8eaed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.55rem 0.75rem;

    .info {
      .title {
        font-size: $subFontSize;
        color: #333;
      }

      .time {
        font-size: $fontSize;
        color: #999;
        margin-top: 0.25rem;
      }
    }

    .number {
      font-size: $h1;
      color: $primaryColor;
    }

    .diture {
      font-size: $h1;
      color: rgba(102, 102, 102, 1);
    }
  }
}
</style>
